export const translationConfig = {
  common: ['Common.GameSorts'],
  feature: 'Feature.GamePage'
};

export default translationConfig;
